<template>
  <Teleport to="body">
    <div class="pointer-events-none fixed bottom-4 left-1/2 z-[210] w-max max-w-[calc(100vw-2rem)] -translate-x-1/2 space-y-2">
      <TransitionGroup name="toast">
        <div
          v-for="t in items"
          :key="t.id"
          :class="['pointer-events-auto flex items-center gap-3 rounded-full px-4 py-2 text-sm font-bold text-white shadow-2xl backdrop-blur',
                   t.type === 'ok' ? 'bg-success' : t.type === 'err' ? 'bg-destructive' : 'bg-primary']"
        >
          <span class="min-w-0">{{ t.msg }}</span>
          <button v-if="t.acao" type="button"
            class="shrink-0 rounded-full bg-white/20 px-3 py-1 text-xs font-extrabold uppercase tracking-wide hover:bg-white/30"
            @click="clicar(t)">{{ t.acao.label }}</button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, onUnmounted } from "vue";
import { onToast, type ToastAcao } from "@/stores/ui";

type T = { id: string; msg: string; type?: "ok" | "err" | "info"; ttl?: number; acao?: ToastAcao };
const items = ref<T[]>([]);

function remover(id: string) { items.value = items.value.filter((x) => x.id !== id); }
async function clicar(t: T) {
  remover(t.id);
  try { await t.acao?.onClick(); } catch { /* quem chama trata e avisa */ }
}

const unsub = onToast((t) => {
  items.value.push(t);
  setTimeout(() => remover(t.id), t.ttl ?? 2500);
});
onUnmounted(() => unsub());
</script>

<style>
.toast-enter-active, .toast-leave-active { transition: opacity .25s, transform .25s; }
.toast-enter-from { opacity: 0; transform: translateY(20px); }
.toast-leave-to { opacity: 0; transform: translateY(-10px); }
</style>
